import React from 'react';
import { asset } from '../../services/api';

function ProductList({ produits, handleEdit, handleDelete }) {
  return (
    <div className="mes-produits-container">
      <div className="mes-produits-header">
        <h2>Liste des Produits Validés</h2>
      </div>

      <div className="table-responsive">
        <table className="mes-produits-table">
          <thead>
            <tr>
              <th>Catégorie</th>
              <th>Titre</th>
              <th>Description</th>
              <th>Prix</th>
              <th>Stock</th>
              <th>Lieu</th> 
              <th>Image</th>
              <th>Nom du vendeur</th>
              <th>Email</th>
              <th>Téléphone</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {produits.map((prod) => (
              <tr key={prod.id}>
                <td>{prod.categorie}</td>
                <td>{prod.title}</td>
                <td>{prod.description}</td>
                <td>{prod.price} Ar</td>
                <td>{prod.stock} kg</td>
                <td>{prod.lieu}</td>
                <td>
                  {prod.img && (
                    <img
                      src={asset(prod.img)}
                      alt="Produit"
                      width="60"
                      height="60"
                      style={{ objectFit: 'cover', borderRadius: '6px' }}
                    />
                  )}
                </td>
                <td>{prod.vendeur_nom} {prod.vendeur_prenom}</td>
                <td>{prod.vendeur_email}</td>
                <td>📞 {prod.vendeur_telephone}</td>
                <td className="action-buttons">
                  <button onClick={() => handleEdit(prod)} className="edit-button">
                    ✏️
                  </button>
                  <button
                    onClick={() => handleDelete(prod.id)}
                    className="delete-button"
                  >
                    🗑️
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ProductList;
